<div class="shimmer-container">
  @for (line of linesArray; track line) {
    <div 
      class="placeholder-shimmer"
      [style.width]="width"
      [style.height]="height"
      [style.border-radius]="borderRadius"
      [style.margin-bottom]="marginBottom"
    ></div>
  }
</div>
